import { PageHero } from "@/components/public/Layout";
import { Reveal, SectionLabel, ArchImage, useSettings } from "@/components/public/shared";
import Founders from "@/components/public/Founders";
import { IMG } from "@/lib/images";

export default function About() {
  const s = useSettings();
  const about = s.about || {};
  const blocks = [
    { k: "Our Story", v: about.story },
    { k: "Our Philosophy", v: about.philosophy },
    { k: "Our Vision", v: about.vision },
    { k: "Our Mission", v: about.mission },
  ].filter((b) => b.v);
  const values = [
    { t: "Hospitality First", d: "Every decision begins with the guest experience." },
    { t: "Culinary Craft", d: "Pure vegetarian & Jain, executed with fine-dining precision." },
    { t: "Consistency", d: "Reliable quality across every plate, every day, at any scale." },
    { t: "Operational Excellence", d: "Trained teams, hygiene-first kitchens, seamless execution." },
  ];
  return (
    <div>
      <PageHero label="About Mee2Momos" title="Hospitality built around food, people and craft." subtitle="A premium pure vegetarian & Jain-Friendly F&B hospitality group, growing thoughtfully toward a multi-brand future." image={IMG.chefKitchen} />
      <section className="bg-ivory py-20 sm:py-28">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
          <Reveal className="lg:col-span-5"><ArchImage src={IMG.momoPurple} alt="Signature dim sum" ratio="aspect-[4/5]" /></Reveal>
          <div className="space-y-10 lg:col-span-7">
            {blocks.map((b, i) => (
              <Reveal key={b.k} delay={i * 60}>
                <SectionLabel>{b.k}</SectionLabel>
                <p className="mt-4 text-lg leading-relaxed text-espresso/90">{b.v}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Founders bg="bg-cream" />
      <section className="bg-cream py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mb-14 text-center"><SectionLabel className="justify-center">Our Values</SectionLabel>
            <h2 className="mt-5 font-display text-4xl font-light text-espresso sm:text-5xl">What we stand for</h2></Reveal>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v, i) => (
              <Reveal key={v.t} delay={i * 60}>
                <div className="h-full border border-subtle bg-ivory p-8">
                  <span className="font-display text-4xl text-gold/40">0{i + 1}</span>
                  <h3 className="mt-3 font-display text-xl text-espresso">{v.t}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-inkmuted">{v.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
